module.exports = __webpack_public_path__ + "static/media/light-logo.83486621.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/light-logo.png
// module id = 408
// module chunks = 0